import React from 'react';

const SendPlaneFillIcon = ({ width, height, color }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
            <path
                d="M1.29754 6.21041C0.94918 6.09429 0.946433 5.90694 1.30471 5.78751L14.0289 1.54613C14.3811 1.42869 14.5832 1.6259 14.4845 1.97142L10.8491 14.6956C10.7484 15.0479 10.5453 15.0601 10.3964 14.7252L8.00013 9.33351L12.0001 4.00016L6.6668 8.00018L1.29754 6.21041Z"
                fill={color}
            />
        </svg>
    );
};

export default SendPlaneFillIcon;
